import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${COLORS.BgLight};
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding: 32px 32px 24px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px 24px 16px;
    }
`;

export const User = styled.div`
    margin-bottom: 16px;
    justify-content: space-between;
`;

export const UserInfo = styled.div`
    column-gap: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        column-gap: 8px;
    }
`;

export const Avatar = styled(LazyLoadImage)<{ src: string }>`
    width: 44px;
    height: 41.5px;
`;

export const UserDetail = styled.div`
    flex-direction: column;
    margin: auto;
`;

export const Grades = styled.div`
    column-gap: 2px;
`;

export const Star = styled(LazyLoadImage)<{ src: string }>`
    width: 24px;
    height: 24px;
    padding: 2px;
`;

export const Text = styled(Paragraph4)<{ isShowAllLines: boolean, linesNumber: number, overflow: string }>`
    display: -webkit-box;
    -webkit-line-clamp: ${({ isShowAllLines, linesNumber }) => isShowAllLines ? 'inherit' : linesNumber};
    -webkit-box-orient: vertical;
    overflow: ${({ overflow }) => overflow ? overflow : 'hidden'};
    word-break: break-word;
    margin-bottom: 8px;
`;

export const ShowLinesBtn = styled(Button)`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    height: 36px;
    ${FONTS.MediumXS};
    padding: 0;
`;
